

module.exports = __webpack_require__.stylable.create(
    "CalendarsInfoPopover1719238571",
    {"classes":{"root":"CalendarsInfoPopover1719238571__root","CalendarsContainer":"CalendarsInfoPopover1719238571__CalendarsContainer","Calendars":"CalendarsInfoPopover1719238571__Calendars","infoIcon":"CalendarsInfoPopover1719238571__infoIcon","CalendarRow":"CalendarsInfoPopover1719238571__CalendarRow","ColorIndicator":"CalendarsInfoPopover1719238571__ColorIndicator","CalendarTitle":"CalendarsInfoPopover1719238571__CalendarTitle","c1":"CalendarsInfoPopover1719238571__c1"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '14px'}\"","MainColor":"\"fallback(color(--calendarsFontColor), fallback(color(--daysColor), color(color-5)))\"","MainFont":"\"fallback(font(--calendarsFont), font({theme: 'Body-M', size: '16px', lineHeight: '14px'}))\""},"keyframes":{}},
    "",
    16,
    "CalendarsInfoPopover1719238571",
    null
);
